import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webhook',
  templateUrl: './webhook.component.html',
  styleUrls: ['./webhook.component.css']
})
export class WebhookComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  copyButton1: boolean = true;
  copiedButton1: boolean = false;

  copyButton2: boolean = true;
  copiedButton2: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }


  requestData = `
  curl -X POST https://api.optimusdrive.ai/v1/customer/webhook \ -H "Content-Type: application/json" \ -H 'authorization: XXX' \ 
  -d '{
        "url": "https://webhook.site/93483eb45-939d-4bcd-b369-de55b37401b0"
      }' 

      `


  Data = `
  }`




  sucessData = `
  {
    "data": {
      "url": "https://webhook.site/9483eb45-939d-4bcd-b369-de55b37401b0",
      "id": "5439541c-6bb3-479b-a73a-d35bd69ab9ec",
      "created_at": 1690521581
    },
    "message": "Webhook created successfully"
  }
  
  `

  Error5x = `
  {
    "error": "url is a required field",
    "message": "One or more field is missing"
  }`

  Error4x = `
  {
    "message":"Unauthorized"
  }`

  Error42x = `
  {
    "error": "process_type is a required field when settings is ask me everytime",
    "message": "process_type is a required field"
  }`



  Error401x = `
  {
    "error": {},
    "message": "Unauthorized"
  }
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton = false;
        this.copiedButton = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }



  // List Webhook


  requestData1 = `
  curl -X GET https://api.optimusdrive.ai/v1/customer/webhook \ -H 'authorization: XXX' 

  `


  copyToClipBoard1(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton1 = false;
        this.copiedButton1 = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton1 = true;
          this.copiedButton1 = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard1() {
    this.copyToClipBoard1(this.requestData1);
  }


  sucessData1 = `
  {
    "data": [
      {
        "url": "https://webhook.site/9483eb45-939d-4bcd-b369-de55b37401b0",
        "id": "1deaf77b-217b-4785-8084-92c341c8e382",
        "created_at": 1690523897
      },
      {
        "url": "https://webhook.site/9483eb45-939d-4bcd-b369-de55b37401b0",
        "id": "5439541c-6bb3-479b-a73a-d35bd69ab9ec",
        "created_at": 1690521581
      }
    ],
    "message": "Webhooks fetched successfully"
  }
  `

  Error4x1 = `
  {
    "message":"Unauthorized"
  }`


  // Delete Webhook


  requestData2 = `curl -X DELETE \
  https://api.optimusdrive.ai/v1/customer/webhook/5439541c-6bb3-479b-a73a-d35bd69ab9ec \ -H 'authorization: XXX'

  `

  copyToClipBoard2(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton2 = false;
        this.copiedButton2 = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton2 = true;
          this.copiedButton2 = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard2() {
    this.copyToClipBoard2(this.requestData2);
  }


  sucessData2 = `
  {
    "data": {
      "id": "5439541c-6bb3-479b-a73a-d35bd69ab9ec"
    },
    "message": "Webhook deleted successfully"
  }
  `

  example400 = `
  {
    "error":"invalid id provided",
    "message":"invalid id provided"
  }
  `


  // Pending 

  pending = `
  {
    "type": "vod",
    "data": {
      "id": "0053325e-8301-41a5-9a85-81abed467dd7",
      "created_at": 1690524323,
      "updated_at": 1690524323,
      "input_info": {
        "filename": "Cascade.MOV",
        "duration": 0,
        "height": 0,
        "width": 0
      },
      "output_info": {},
      "source": "oci",
      "source_path": "VideoForOptimizer/Cascade.MOV",
      "crunch_mode": "optimizer",
      "status": "PENDING",
      "output_video_codec": "h264",
      "abr_type": "HLS_MP4",
      "status_history": [
        {
          "status": "PENDING",
          "event_time": 1690524323
        }
      ]
    }
  }`


  preprocessing = `
  {
    "type": "vod",
    "data": {
      "id": "0053325e-8301-41a5-9a85-81abed467dd7",
      "created_at": 1690524323,
      "updated_at": 1690524323,
      "input_info": {
        "filename": "Cascade.MOV",
        "duration": 22,
        "height": 1080,
        "width": 1920
      },
      "output_info": {},
      "source": "oci",
      "source_path": "VideoForOptimizer/Cascade.MOV",
      "crunch_mode": "optimizer",
      "status": "PREPROCESSING",
      "output_video_codec": "h264",
      "abr_type": "HLS_MP4",
      "status_history": [
        {
          "status": "PENDING",
          "event_time": 1690524323
        }
      ]
    }
  }`


  transcoding = `
  {
    "type": "vod",
    "data": {
      "id": "0053325e-8301-41a5-9a85-81abed467dd7",
      "created_at": 1690524323,
      "updated_at": 1690524443,
      "downloading_time": 1,
      "input_info": {
        "resolution": "1920 X 1080 pixels",
        "class_label": "FullHD",
        "frame_rate": "30.000 fps",
        "bit_rate": "3068154 b/s",
        "file_size": 8629183,
        "filename": "Cascade.MOV",
        "duration": 22,
        "height": 1080,
        "width": 1920
      },
      "output_info": {},
      "source": "oci",
      "source_path": "VideoForOptimizer/Cascade.MOV",
      "crunch_mode": "optimizer",
      "status": "TRANSCODING",
      "output_video_codec": "h264",
      "abr_type": "HLS_MP4",
      "status_history": [
        {
          "status": "PENDING",
          "event_time": 1690524323
        },
        {
          "status": "PREPROCESSING",
          "event_time": 1690524330
        },
        {
          "status": "TRANSCODING",
          "event_time": 1690524443
        }
      ]
    }
  }`


  complete = `
  {
    "type": "vod",
    "data": {
      "id": "0053325e-8301-41a5-9a85-81abed467dd7",
      "created_at": 1690524323,
      "updated_at": 1690524466,
      "downloading_time": 1,
      "processing_time": 131,
      "transcoding_time": 17,
      "input_info": {
        "resolution": "1920 X 1080 pixels",
        "class_label": "FullHD",
        "frame_rate": "30.000 fps",
        "bit_rate": "3068154 b/s",
        "file_size": 8629183,
        "filename": "Cascade.MOV",
        "duration": 22,
        "height": 1080,
        "width": 1920
      },
      "output_info": {
        "variants": [
          {
            "name": "Cascade",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/mp4/TP1H264/Cascade.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/Cascade.jpeg",
            "resolution": "1920 X 1080 pixels",
            "class_label": "FullHD",
            "frame_rate": "30.000 fps",
            "bit_rate": "2010514 b/s",
            "file_size": 5941024,
            "height": 1080,
            "width": 1920
          },
          {
            "name": "Cascade",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/mp4/video3/Cascade.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/Cascade.jpeg",
            "resolution": "1920 X 1080 pixels",
            "class_label": "FullHD",
            "frame_rate": "30.000 fps",
            "bit_rate": "2057902 b/s",
            "file_size": 6074303,
            "height": 1080,
            "width": 1920
          },
          {
            "name": "Cascade",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/mp4/video4/Cascade.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/Cascade.jpeg",
            "resolution": "1280 X 720 pixels",
            "class_label": "HD",
            "frame_rate": "30.000 fps",
            "bit_rate": "1241952 b/s",
            "file_size": 3779456,
            "height": 720,
            "width": 1280
          },
          {
            "name": "Cascade",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/mp4/video5/Cascade.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/Cascade.jpeg",
            "resolution": "854 X 480 pixels",
            "class_label": "SD",
            "frame_rate": "30.000 fps",
            "bit_rate": "653594 b/s",
            "file_size": 2124682,
            "height": 480,
            "width": 854
          },
          {
            "name": "Cascade",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/mp4/video6/Cascade.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/Cascade.jpeg",
            "resolution": "640 X 360 pixels",
            "class_label": "SD",
            "frame_rate": "30.000 fps",
            "bit_rate": "397339 b/s",
            "file_size": 1404088,
            "height": 360,
            "width": 640
          },
          {
            "name": "Cascade",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/mp4/video7/Cascade.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/Cascade.jpeg",
            "resolution": "480 X 270 pixels",
            "class_label": "SD",
            "frame_rate": "30.000 fps",
            "bit_rate": "250000 b/s",
            "file_size": 956337,
            "height": 270,
            "width": 480
          }
        ],
        "hls_manifest": "https://optimus-media.crunchmediaworks.com/vod/0053325e-8301-41a5-9a85-81abed467dd7/hls/master.m3u8"
      },
      "source": "oci",
      "source_path": "VideoForOptimizer/Cascade.MOV",
      "crunch_mode": "optimizer",
      "status": "COMPLETED",
      "output_video_codec": "h264",
      "abr_type": "HLS_MP4",
      "status_history": [
        {
          "status": "PENDING",
          "event_time": 1690524323
        },
        {
          "status": "PREPROCESSING",
          "event_time": 1690524330
        },
        {
          "status": "TRANSCODING",
          "event_time": 1690524443
        },
        {
          "status": "POSTPROCESSING",
          "event_time": 1690524468
        },
        {
          "status": "COMPLETED",
          "event_time": 1690524468
        }
      ]
    }
  }`

  example500 = `
  {
    "message": "Internal server error"
  }
   `

}
